import axiosClient from "./axiosClient";

const bannerServiceApi = {
  getById: (id) => {
    const url = `api/banner/${id}`;
    return axiosClient.get(url, id);
  },

  getAll: () => {
    const url = `api/banner/getall`;
    return axiosClient.get(url);
  },

  getAds: () => {
    const url = `api/banner/getAds`;
    return axiosClient.get(url);
  },

  createEvent: (data) => {
    const url = `api/banner`;
    return axiosClient.post(url, data);
  },

  updateEvent: (id, data) => {
    const url = `api/banner/${id}`;
    return axiosClient.put(url, data);
  },

  deleteBannerById: (id) => {
    const url = `api/banner/${id}`;
    return axiosClient.delete(url, id);
  },
};
export default bannerServiceApi;
